import React from 'react';
export function SocialProofBar() {
  return <section className="w-full bg-[#1a0d00] py-12 px-4" data-id="element-270">
      <div className="max-w-5xl mx-auto" data-id="element-271">
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 mb-12 text-center" data-id="element-272">
          <div data-id="element-273">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-274">
              +300
            </div>
            <div className="text-[#FF6B00] text-sm font-semibold mt-1" data-id="element-275">
              profes confían
            </div>
          </div>
          <div data-id="element-276">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-277">
              6+6
            </div>
            <div className="text-[#FF6B00] text-sm font-semibold mt-1" data-id="element-278">
              Tomos + Bonos
            </div>
          </div>
          <div data-id="element-279">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-280">
              4.9/5
            </div>
            <div className="text-[#FF6B00] text-sm font-semibold mt-1" data-id="element-281">
              calificación ⭐
            </div>
          </div>
          <div data-id="element-282">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-283">🇦🇷</div>
            <div className="text-[#FF6B00] text-sm font-semibold mt-1" data-id="element-284">
              Todo el país
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4" data-id="element-285">
          <div className="flex items-start gap-3 bg-black/40 border border-[#FF6B00]/20 rounded-xl p-4" data-id="element-286">
            <div className="w-10 h-10 rounded-full bg-[#FF6B00]/20 flex items-center justify-center text-[#FF6B00] font-black text-sm flex-shrink-0" data-id="element-287">
              MR
            </div>
            <div data-id="element-288">
              <div className="text-[#FF6B00] text-xs mb-1" data-id="element-289">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-290">
                "Organicé todo el año en una tarde. Ahora tengo cada clase
                pensada y secuenciada."
              </p>
              <p className="text-gray-300 text-xs mt-1" data-id="element-291">
                — María Rosa, Buenos Aires | Profesora de Folklore en Escuela
                Primaria
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3 bg-black/40 border border-[#FF6B00]/20 rounded-xl p-4" data-id="element-292">
            <div className="w-10 h-10 rounded-full bg-[#FF6B00]/20 flex items-center justify-center text-[#FF6B00] font-black text-sm flex-shrink-0" data-id="element-293">
              JC
            </div>
            <div data-id="element-294">
              <div className="text-[#FF6B00] text-xs mb-1" data-id="element-295">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-296">
                "24 clases con progresión real. Los alumnos avanzan clase a
                clase."
              </p>
              <p className="text-gray-300 text-xs mt-1" data-id="element-297">
                — Jorge C., Rosario | Profesor de Folklore en Academia Privada
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3 bg-black/40 border border-[#FF6B00]/20 rounded-xl p-4" data-id="element-298">
            <div className="w-10 h-10 rounded-full bg-[#FF6B00]/20 flex items-center justify-center text-[#FF6B00] font-black text-sm flex-shrink-0" data-id="element-299">
              SV
            </div>
            <div data-id="element-300">
              <div className="text-[#FF6B00] text-xs mb-1" data-id="element-301">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-302">
                "Adapto el mismo contenido a todas las edades en 5 minutos.
                Antes me llevaba horas."
              </p>
              <p className="text-gray-300 text-xs mt-1" data-id="element-303">
                — Sofía V., Córdoba | Profesora de Folklore Independiente
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}